import Phaser from 'phaser';

class Message extends Phaser.GameObjects.Text {
    constructor(scene, x, y, fontSize, text = '') {
        super(scene, x, y, text, {
            font: `${fontSize} Halvar`,
            fill: 'rgba(0, 0, 0, 1)',
            alpha: 0,
        });

        this.setAlpha(0);

        scene.add.existing(this);
    }

    show(text = null) {
        if (text) this.setText(text);
        this.scene.tweens.add({
            targets: this,
            y: this.y - 15,
            alpha: 1,
            ease: 'Cubic.easeInOut',
            duration: 700,
        });
    }

    hide(callback) {
        this.scene.tweens.add({
            targets: this,
            y: this.y + 15,
            alpha: 0,
            ease: 'Cubic.easeInOut',
            duration: 500,
            onComplete: () => {
                if (callback) callback();
            },
        });
    }
}

export default Message;
